module.exports = __webpack_public_path__ + "img/sergeant-reason-icon3.77380b57.png";